import {IFilterFunction} from "angular";
import {ReportPeriod} from "../../models/ReportPeriod";

export const ReportPeriodTranslationPipe = "tfOtReportPeriodTranslation";

export function reportPeriodTranslationPipe(): IFilterFunction {
    return (period: ReportPeriod | null) => {
        if (period == null) {
            return null;
        } else {
            return "report." + period;
        }
    };
}
